import { memo } from 'react'
import {
  EdgeProps,
  getBezierPath,
  EdgeLabelRenderer,
  BaseEdge,
} from '@xyflow/react'

function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  selected,
  style = {},
  markerEnd,
}: EdgeProps) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  })

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          strokeWidth: selected ? 3.5 : 2.5,
          stroke: selected ? '#38bdf8' : '#6b7280',
          ...style,
        }}
      />

      {/* Animated background edge for selected state */}
      {selected && (
        <path
          d={edgePath}
          fill="none"
          stroke="#0ea5e9"
          strokeWidth={8}
          opacity={0.25}
          className="pointer-events-none"
          style={{
            filter: 'blur(4px)',
          }}
        />
      )}

      {/* Edge label on hover - shows connection info */}
      {selected && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
            }}
            className="nodrag nopan"
          >
            <div className="bg-white px-2 py-1 rounded shadow-md border border-gray-200 text-xs font-medium text-gray-700 animate-fadeIn">
              Connection
            </div>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  )
}

export default memo(CustomEdge)
